let React = require('react');
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';
import TableFooter from './TableFooter.jsx';

const Table = (props) => {
  
    return (
        <div className="bottom-separator-xxs">
            <TableHeader data={props.data} limitesCliente={props.limitesCliente}  updateLimitsFunction={props.updateLimitsFunction} seleccionDeEmpresa={props.seleccionDeEmpresa}/>
            <hr className="separator-line separator-light" />
            <TableBody
                data={props.data}
                internalData={props.internalData}
                updateLimitsFunction={props.updateLimitsFunction}
                editNotifyFn={props.editNotifyFn}
                functions={props.functions}
                aparicionLapizEdicion={props.aparicionLapizEdicion}
                comienzoDeEdicion={props.comienzoDeEdicion}
                desaparicionLapizEdicion={props.desaparicionLapizEdicion}
                cancelEdicionLimite={props.cancelEdicionLimite}
                cancelEdicionNovedad={props.cancelEdicionNovedad}
                aceptarEdicion={props.aceptarEdicion}
                mostrarMensajeLimitesIguales={props.mostrarMensajeLimitesIguales}
                modificacionLimite={props.modificacionLimite}
                modificacionNovedad={props.modificacionNovedad}
                muestraEditadoNovedad={props.muestraEditadoNovedad}
                ocultaEditadoNovedad={props.ocultaEditadoNovedad}/>
            <hr className="separator-line separator-light" />
            <TableFooter data={props.data} internalData={props.internalData} />
        </div>
    );
}


export default Table